import { ICloneable } from '../../contracts/cloneable.js';
import { IDataComparable } from '../../contracts/data-comparable.js';

export class SerialIdGenerator implements IDataComparable, ICloneable {
  private _nextValue: number;

  constructor(
      start: number | null = null,
  ) {
    this._nextValue = start ?? 1;
  }

  get nextValue(): number {
    return this._nextValue;
  }

  generate(): number {
    return this._nextValue++;
  }

  clone(): this {
    return new SerialIdGenerator(this._nextValue) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return this._nextValue === other._nextValue;
  }
}
